















































import { Component, Mixins } from "vue-property-decorator";
import mixins from "@/mixins";
import { Getter, State } from "vuex-class";
import { UserWealth } from "@foxone/api/src/models/defi";
import { Balance } from "@foxone/api/src/models/hfox";
import MixinPortfolio from "@/projects/wallet/components/home/MixinPortfolio.vue";
import HFoxPortfolio from "@/projects/wallet/components/home/HFoxPortfolio.vue";
import DefiPortfolio from "@/projects/wallet/components/home/DefiPortfolio.vue";
import { showServiceDisabled } from "@/utils/helper";

const CardSymbols = {
  mixin: Symbol("mixin"),
  hfox: Symbol("hfox"),
  defi: Symbol("defi")
};

@Component({
  components: {
    MixinPortfolio,
    DefiPortfolio,
    "hfox-portfolio": HFoxPortfolio
  }
})
class Index extends Mixins(mixins.page, mixins.processOrders) {
  @Getter("auth/isLogged") isLogged;

  @Getter("wallet/mixin/getTotalUsd") mixinTotalUsd;

  @State(state => state.app.mixinLoginOutDate) mixinLoginOutDate;

  @State(state => state.hfox.balance) hfoxAssets!: Balance;

  @State(state => state.defi.account.wealthes) defiAssets!: UserWealth;

  @State(state => state.wallet.mixin.hidden) hidden;

  @State(state => state.app.config.source) source;

  needAuth = false;

  CardSymbols = CardSymbols;

  get bottomNav() {
    return "wallet";
  }

  get title() {
    return this.$t("common.assets") as string;
  }

  get appbar(): any {
    return {
      show: true,
      back: false,
      align: "center"
    };
  }

  get meta() {
    const fiat = this.$common.utils.currency.fiat;
    const currenySymbol = this.$common.utils.currency.getCurrentCurrency(
      this.$store
    );
    const hideText = "*****";

    const hfoxAssets = this.hfoxAssets || {};
    const hfoxBalance = hfoxAssets.balance || 0;

    const totalUSDT = Number(this.mixinTotalUsd) + Number(hfoxBalance);
    const totalFiat = this.hidden
      ? hideText
      : fiat(this, {
          value: totalUSDT,
          from: "USDT",
          dispaly: "none"
        });

    return {
      totalFiat,
      currenySymbol,
      showDepoist: this.source === "s3"
    };
  }

  handleCardClick(value) {
    if (!this.isLogged) {
      this.$common.utils.helper.requestLogin(this);
      return;
    }

    switch (value) {
      case CardSymbols.mixin:
        this.handleToMixinAssets();
        break;
      case CardSymbols.hfox:
        this.handleToHfox();
        break;
      case CardSymbols.defi:
        this.handleToDefi();
        break;
    }
  }

  handleToMixinAssets() {
    if (this.mixinLoginOutDate) {
      this.$common.utils.helper.requestMixinLogin(this);
      return;
    }
    this.$common.utils.helper.toFusionPath(this, "wallet", { name: "wallet" });
  }

  handleToHfox() {
    if (!this.$store.state.app.config.hfox_disabled) {
      this.$common.utils.helper.toFusionPath(this, "hfox", { name: "index" });
    } else {
      showServiceDisabled(this);
    }
  }

  handleToDefi() {
    this.$common.utils.helper.toFusionPath(this, "defi", { name: "mine" });
  }

  handleToDeposit() {
    this.$router.push({ name: "trade-fiat-wyre" });
  }
}
export default Index;
